import { IconJob } from '@components/icons/job';

import { useStore } from 'models/stores';

import EmptyStateCard from './EmptyStateCard';

function NoAvailableJobs() {
  const { uiStore } = useStore();
  return (
    <EmptyStateCard
      icon={<IconJob />}
      heading={uiStore.t('job_list_no_openings_main')}
      sub={uiStore.t('job_list_no_openings_sub')}
    />
  );
}

export default NoAvailableJobs;
